import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import Login from '../routes/auth/Login';

import { getAuthUser, getOperator } from '../redux/actions/AuthActions';
// import { getConfig } from '../redux/actions/ConfigActions';
import { LoadingScreen } from '../components/LoadingScreen';

//route
import AppRoutes from './AppRoutes';
import ResetPassword from '../routes/auth/ResetPassword';
// import Signup from "../routes/auth/Signup";

function MainApp(props) {
  // state = {
  //   isLoading: true,
  // };
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const isMount = useRef(false);

  useEffect(() => {
    isMount.current = true;

    function fetchData() {
      if (isMount) {
        // dispatch(getConfig());
        dispatch(getAuthUser())
          .then(() => {
            // dispatch(getOperator());
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
    fetchData();

    return () => {
      isMount.current = false;
    };
  }, [dispatch]);

  if (loading) {
    return <LoadingScreen />;
  }

  const { location, match } = props;
  if (location.pathname === '/') {
    return <Redirect to={'/app/revenue'} />;
  }

  return (
    <React.Fragment>
      {/* <IntlProvider locale={'vi'}> */}
      <Switch>
        <Route exact path="/login" component={Login}></Route>
        <Route exact path="/resetpassword" component={ResetPassword}></Route>
        {/* <Route exact path="/signup" component={Signup}></Route> */}
        <Route path={`${match.url}app`} component={AppRoutes}></Route>
      </Switch>
      {/* </IntlProvider> */}
    </React.Fragment>
  );
}

export default withRouter(MainApp);
